import React from "react";
import { Divider, Text, Stack } from "@mantine/core";
import { cedisLocale } from "../../helpers/utilities";
import { RedeemedBenefitsDisplay } from "./redeemed-benefits-display";

const BillSummary = ({
  // Bill data
  subTotal = 0,
  totalCharges = 0,
  totalDiscount = 0,
  totalDue = 0,
  totalPayments = 0,
  balance = 0,

  // Discount details
  totalItemDiscounts = 0,
  totalBillDiscount = 0,
  billDiscount = 0,
  billDiscountType = "value",

  // Redeemed benefits
  redeemedBenefits = [],
  onDeleteBenefit,
  onClearAllBenefits,

  // Action handlers
  onAddNote,
  onAddDiscount,
  onAddCharges,

  // UI state
  hasNote = false,
  hasDiscount = false,
  hasCharges = false,
  isDraft = false,
  draftBillId = null,

  // Children for additional content
  children,

  // Custom styling
  className = "",
}) => {
  return (
    <div>
      <Stack spacing="xs" mt={10}>
        {/* Discounts Section */}
        {/* {totalDiscount > 0 && (
          <div className="border rounded-3 p-2">
            <strong className="text-success">Discounts</strong>
            {totalItemDiscounts > 0 && (
              <div className="d-flex justify-content-between my-2">
                <Text size="sm">Item Discounts</Text>
                <Text size="sm">-{cedisLocale.format(totalItemDiscounts)}</Text>
              </div>
            )}

            {billDiscount > 0 && (
              <div className="d-flex justify-content-between my-2">
                <Text size="sm">
                  Bill Discount (
                  {((billDiscount / subTotal) * 100).toPrecision(2)}%)
                </Text>
                <Text size="sm">{cedisLocale.format(totalBillDiscount)}</Text>
              </div>
            )}
          </div>
        )} */}

        {/* Redeemed Benefits Display */}
        {redeemedBenefits && redeemedBenefits.length > 0 && (
          <RedeemedBenefitsDisplay
            redeemedBenefits={redeemedBenefits}
            onDeleteBenefit={onDeleteBenefit}
            onClearAll={onClearAllBenefits}
          />
        )}

        {/* Bill Summary */}
        <div className="d-flex justify-content-between mb-0 pb-0">
          <Text size="md">Subtotal</Text>
          <Text size="md" weight={500}>
            {cedisLocale.format(subTotal)}
          </Text>
        </div>

        {totalCharges > 0 && (
          <div className="d-flex justify-content-between">
            <Text size="sm">Charges</Text>
            <Text size="sm" weight={600}>
              {cedisLocale.format(totalCharges.toFixed(1))}
            </Text>
          </div>
        )}

        {totalDiscount > 0 && (
          <div className="d-flex justify-content-between">
            <Text size="sm">Total Discount</Text>
            <Text size="sm" color="red" weight={800}>
              -{cedisLocale.format(totalDiscount)}
            </Text>
          </div>
        )}

        <Divider className="my-1" />

        <div className="d-flex justify-content-between mb-0">
          <Text weight={600} size="lg">
            Total Due
          </Text>
          <Text weight={800} size="lg">
            {cedisLocale.format(totalDue.toFixed(1))}
          </Text>
        </div>

        <div className="d-flex justify-content-between m-0">
          <Text size="sm" m={0}>
            Paid
          </Text>
          <Text size="lg" weight={600}>
            {cedisLocale.format(totalPayments.toFixed(1))}
          </Text>
        </div>

        <div className="d-flex justify-content-between m-0">
          <Text size="sm" m={0}>
            Balance
          </Text>
          <Text size="lg" weight={800} color={balance !== 0 ? "red" : "green"}>
            {cedisLocale.format(balance.toFixed(1))}
          </Text>
        </div>
        {children}
      </Stack>
    </div>
  );
};

export default BillSummary;
